import { render, staticRenderFns } from "./AprenAiPhone.vue?vue&type=template&id=a50c60dc&scoped=true"
import script from "./AprenAiPhone.vue?vue&type=script&lang=js"
export * from "./AprenAiPhone.vue?vue&type=script&lang=js"
import style0 from "./AprenAiPhone.vue?vue&type=style&index=0&id=a50c60dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a50c60dc",
  null
  
)

export default component.exports